module.exports = __webpack_public_path__ + "media/images/talent/flow-01-f239d3d52ccdf76449e3376e29b886ae.png";